import { observer } from 'mobx-react-lite'
import {
  BetInput,
  BottomModalContentConfig,
  BottomModalTypes,
  Confirm,
  GameStart,
  PlayerOptions,
  SidePots,
  Observers,
  Walkthrough,
  ThreeCardBet,
  ShowCards,
  ChatContent
} from './Content'
import { CallOptions } from './Content/CallOptions'
import { CommandsContextProvider } from '../../../screens/new-design/hooks/useCommonCommands'
interface BottomModalProps {
  config?: BottomModalContentConfig
}

export const BottomModalContent = observer(({ config, ...rest }: BottomModalProps) => {
  if (!config) return null
  return (
    <CommandsContextProvider context="legacy">
      <Component config={config} {...rest} />
    </CommandsContextProvider>
  )
})

const Component = observer(({ config }: BottomModalProps) => {
  const { kind, props } = config ?? {}
  switch (kind) {
    case BottomModalTypes.Observers:
      return <Observers {...props} />
    case BottomModalTypes.Chats:
      return <ChatContent />
    case BottomModalTypes.Confirm:
      return <Confirm {...props} />
    case BottomModalTypes.GameStart:
      return <GameStart {...props} />
    case BottomModalTypes.Bet:
      return <BetInput {...props} />
    case BottomModalTypes.Walkthrough:
      return <Walkthrough {...props} />
    case BottomModalTypes.PlayerOptions:
      return <PlayerOptions {...props} />
    case BottomModalTypes.SidePots:
      return <SidePots {...props} />
    case BottomModalTypes.CallOptions:
      return <CallOptions {...props} />
    case BottomModalTypes.ThreeCardBet:
      return <ThreeCardBet {...props} />
    case BottomModalTypes.ShowCards:
      return <ShowCards {...props} />
  }
})
